import { FloatingPosition, Menu } from '@mantine/core';
import { IconDotsVertical } from '@tabler/icons-react';

type AsyncVoidFunction = () => Promise<void>;

type AsyncNullFunction = () => Promise<null>;

export interface DropDownMenuItem {
  name: string;
  onClick: AsyncNullFunction | AsyncVoidFunction | (() => void) | (() => null);
}

interface DotsMenuProps {
  items: DropDownMenuItem[];
  width?: number;
}

export const DotsMenu = ({ items, width = 200 }: DotsMenuProps) => {
  return (
    <Menu shadow="md" width={width}>
      <Menu.Target>
        <button>
          <IconDotsVertical />
        </button>
      </Menu.Target>

      <Menu.Dropdown>
        {items.map(({ name, onClick }) => (
          <Menu.Item key={name} onClick={onClick}>
            {name}
          </Menu.Item>
        ))}
      </Menu.Dropdown>
    </Menu>
  );
};

interface GenericMenuProps extends DotsMenuProps {
  component: JSX.Element;
  position?: FloatingPosition;
  disabled?: boolean;
}

export const GenericMenu = ({
  component,
  items,
  disabled = false,
  width = 200,
  position = 'bottom',
}: GenericMenuProps) => {
  return (
    <Menu
      disabled={disabled}
      shadow="md"
      width={width}
      classNames={{}}
      position={position}
    >
      <Menu.Target>
        <span className="cursor-pointer">{component}</span>
      </Menu.Target>

      <Menu.Dropdown>
        {items.map(({ name, onClick }) => (
          <Menu.Item onClick={onClick}> {name}</Menu.Item>
        ))}
      </Menu.Dropdown>
    </Menu>
  );
};
